// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2Ksxa","Open":"SideDrawer_Open__24IPS","Close":"SideDrawer_Close__IexFO","Logo":"SideDrawer_Logo__1s538"};